import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SelectRole from '../../FirmOnboarding/Components/SelectRole';

const AddManufacturer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const manufacturerModal = location.state?.manufacturerModal;
    console.log('manufacturerModal', manufacturerModal)
    const manufacturerRoleFlow = useSelector(state => state.FirmOnboardingReducer.manufacturerRoleFlow);
    const {
        existingFirm
    } = useSelector(state => state.FirmOnboardingReducer || {});
    const handleRoleContinue = useCallback(({ isAnyRoleGstRequired, hasGST }) => {
        if (manufacturerRoleFlow) {
            if (isAnyRoleGstRequired && !hasGST) {
                dispatch({ type: 'SET_GST_FLOW', payload: true });
                navigate('/my-account/input-screen');
            } else {
                navigate('/my-account/confirm');
            }
            return;
        }
        if(existingFirm && hasGST) {
            navigate('/my-account/confirm', { state: { manufacturerModal: manufacturerModal ? manufacturerModal : false } });
            return;
        }
        navigate('/my-account/input-screen');
    }, [dispatch, manufacturerRoleFlow, navigate]);
    return (
        <Box sx={{ px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <SelectRole
            twoColumnLayout={true}
            onContinue={handleRoleContinue}
            ButtonTop = {true}
            manufacturerModal = {manufacturerModal}
        />
        </Box>
    );
};

export default AddManufacturer;
